var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { API_SERVER_URL } from '../../utils/common/apiConfig';
import httpGet from '../../utils/http/httpGet';
var defaultParameter = {
    adult: 'all',
    free: 'all',
    guest: 'all',
    scope: 'all',
    personal: 'N',
    lastFrequency: 'Y',
    totalCountYn: 'y',
    pageNo: 1,
    pageSize: 20,
};
/**
 * 에피소드 목록 정보를 요청합니다.
 *
 * @param requestParameter: 요청 파라미터
 * @param requestConfig: axios 요청 설정
 */
var fetchEpisodes = function (requestParameter, requestConfig) {
    if (requestConfig === void 0) { requestConfig = {}; }
    var params = __assign(__assign({}, defaultParameter), requestParameter);
    var filledRequestConfig = __assign(__assign({}, requestConfig), { params: params });
    return httpGet("".concat(API_SERVER_URL).concat(API_URLS.EPISODES), filledRequestConfig)
        .then(function (response) {
        return response.body;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchEpisodes;
